export {};

type PriceMode = 'b2b' | 'consumer';

const STORAGE_KEY = 'priceMode';
const DEFAULT_MODE: PriceMode = 'b2b';

const getStoredMode = (): PriceMode =>
    localStorage.getItem(STORAGE_KEY) === 'consumer' ? 'consumer' : DEFAULT_MODE;

const applyMode = (mode: PriceMode): void => {
    document.documentElement.dataset.priceMode = mode;
};

applyMode(getStoredMode());

document.addEventListener('click', (event: Event) => {
    const target = (event.target as HTMLElement)?.closest<HTMLElement>('[data-price-mode-set]');

    if (!target) return;

    const mode: PriceMode = target.dataset.priceModeSet === 'consumer' ? 'consumer' : 'b2b';

    localStorage.setItem(STORAGE_KEY, mode);
    applyMode(mode);
});
